import React, { useEffect, useState } from 'react';
import css from './App.module.css';
import CategoryItem from './components/CategoryItem';
import ElementorButton from './components/ElementorButton';
import PostItem from './components/PostItem';
import { TextDomain } from './constants/TextDomain';
import { Category } from './models/Category';
import { WPPost } from './models/WPPost';
import { getCategories, getPosts } from './utils/api';

const { __ } = window.wp.i18n;

function App() {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [page, setPage] = useState(1);
    const [isLastPage, setIsLastPage] = useState(true);
    const [posts, setPosts] = useState<WPPost[]>([]);
    const [categories, setCategories] = useState<Category[]>([]);
    const [selectedCategories, setSelectedCategories] = useState<number[]>([]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const categs = await getCategories();
                setCategories(categs);
            } catch (e) {
                setCategories([]);
            }
        };

        fetchCategories();
    }, []);

    useEffect(() => {
        const doFetch = async () => {
            try {
                setIsLoading(true);
                const pagedPosts = await getPosts(page, selectedCategories);
                setPosts((posts) => [...posts, ...pagedPosts.items]);
                setIsLastPage(pagedPosts.isLastPage);
                setIsLoading(false);
            } catch (e) {
                setPosts([]);
                setIsLoading(false);
            }
        };

        doFetch();
    }, [page, selectedCategories]);

    const handleAllCategoriesClick = () => {
        setSelectedCategories([]);
        setPage(1);
        setPosts([]);
    };

    const handleToggleCategory = (categoryId: number) => {
        let newSelectedCategories;

        const categoryIdx = selectedCategories.findIndex((id) => categoryId === id);
        if (categoryIdx === -1) {
            newSelectedCategories = [...selectedCategories, categoryId];
        } else {
            newSelectedCategories = [...selectedCategories.slice(0, categoryIdx), ...selectedCategories.slice(categoryIdx + 1)];
        }

        setSelectedCategories(newSelectedCategories);
        setPage(1);
        setPosts([]);
    };

    const handleLoadMore = () => {
        setPage((page) => page + 1);
    };

    return (
        <div className={css.App}>
            {categories.length > 0 && (
                <div className={css.CategoriesHolder}>
                    <CategoryItem label={__('All', TextDomain)} isSelected={selectedCategories.length === 0} onClick={handleAllCategoriesClick} />
                    {categories.map((category) => (
                        <CategoryItem
                            key={category.id}
                            label={category.name}
                            isSelected={selectedCategories.includes(category.id)}
                            onClick={() => handleToggleCategory(category.id)}
                        />
                    ))}
                </div>
            )}

            <div className={css.PostsGrid}>
                {posts.map((post) => (
                    <PostItem key={post.id} post={post} />
                ))}
            </div>
            {isLoading && <div className={css.LoadingHolder}>{__('Loading...', TextDomain)}</div>}
            {!isLoading && posts.length === 0 && <div>{__('No posts found.', TextDomain)}</div>}
            {!isLastPage && !isLoading && (
                <div className={css.LoadMoreHolder}>
                    <ElementorButton onClick={handleLoadMore}>{__('Load more', TextDomain)}</ElementorButton>
                </div>
            )}
        </div>
    );
}

export default App;
